import { addressUtilsResolver } from "@layerswap/utils";
export function addressFormat(props) {
    const { address, network, providerName } = props;
    try {
        return addressUtilsResolver.addressFormat({ address, network, providerName });
    }
    catch (err) {
        return address;
    }
}
